import { configureStore } from "@reduxjs/toolkit";
import { cartReducer } from "./cartSlice"



// import storageSession from 'reduxjs-toolkit-persist/lib/storage/session'
import storageSession from 'redux-persist/lib/storage/session'
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const persistConfig = {
  key: 'root',
  storage: storageSession
}

const persistedReducer = persistReducer(persistConfig, cartReducer)





export const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk]
    //   devTools: process.env.NODE_ENV !== 'production',
    // reducer: cartReducer
})


export const persistor = persistStore(store)



